import customerService from "@/services/customer-service";

export default {

  async getCustomers({ commit }, model) {
    return await customerService.getCustomers({ params: model }).then(
      (result) => {
        /* This is a mutation that is being called in the JavaScript file. */
        if (result.data && result.data.length > 0) {
          commit("CLIENT_SUCCESS", result.data);
        }
        return Promise.resolve(result.data);
      },
      (error) => {
        commit("CLIENT_FAILURE");
        return Promise.reject(error);
      }
    );
  },

    CLIENT_FAILURE({ commit }) {
    commit("LOGOUT");
  },

  clientSuccess({ commit }, model) {
     commit("CLIENT_SUCCESS", { data: model });
  },
};
